module.exports = __webpack_public_path__ + "41e4988b8a1e84004eea3cddd4ea7096.pdf";